module.exports = __webpack_public_path__ + "media/images/arrows/down-3fdf4faf253c11dedc555048cb7c9d68.svg";